import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { UserOutlined } from '@ant-design/icons';
import { Menu, Dropdown } from 'antd';

import RibbonButton from 'common/components/button/RibbonButton';

import * as actionsGridView from 'common/components/grid-view/controllers/actions';
import * as ribbonSelectors from '@redux/ribbon/selectors';

import { useFilterGrid } from 'hooks/useFilterGrid';
import { useDisplayFilterButton } from 'hooks/useDisplayFilterButton';

import { FILTER_TYPE_FOLDER } from 'static/Constants';

import './FilterSection.less';

const FilterSection = (props) => {
  const dispatch = useDispatch();
  const view = useSelector(ribbonSelectors.selectRibbon());

  const { gridFilters, updateGridFilter } = useFilterGrid({
    entityType: 'folder',
  });

  const { label, icon, toggle } = useDisplayFilterButton({
    filterOptions: FILTER_TYPE_FOLDER,
    filters: gridFilters,
  });

  const handleFilter = (filter) => {
    dispatch(actionsGridView.resetPageCurrent());

    if (gridFilters.indexOf(filter) > -1) {
      updateGridFilter(gridFilters.filter((val) => val !== filter));
    } else {
      let newFilter = [...gridFilters];
      newFilter.push(filter);
      updateGridFilter(newFilter);
    }
  };

  const disableCreatedByMe = view === 'SHARED_FOLDER_VIEW';

  const menuOptions = (
    <Menu>
      <Menu.Item key='createdByMe' style={{ backgroundColor: 'inherit' }}>
        <RibbonButton
          size='small'
          icon={<UserOutlined />}
          label='Created By Me'
          disabled={disableCreatedByMe}
          onClick={() => handleFilter('createdByMe')}
          toggle={gridFilters.indexOf('createdByMe') > -1}
        />
      </Menu.Item>
    </Menu>
  );

  return (
    <Dropdown overlay={menuOptions} arrow>
      <RibbonButton icon={icon} label={label} toggle={toggle} />
    </Dropdown>
  );
};

export default FilterSection;
